<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="newOrganization()">Create Organization</button>
    <input type='text' placeholder='Search Organizations' (keyup)='search()' [(ngModel)]="searchText" class="searchtext" />
</div>

<ngx-loading [show]="loading"></ngx-loading>

<ngx-datatable 
    #packageTable 
    class='material striped datatable' 
    [rows]='displayOrganizations' 
    [columnMode]='"force"'
    [headerHeight]='40' 
    [footerHeight]='20' 
    [scrollbarH]="true" 
    [scrollbarV]="true" 
    [rowHeight]="40"
    [reorderable]="true">

    <ngx-datatable-column prop="name" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Organization Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="file" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                 Active
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.active}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="130" [maxWidth]="130">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button (click)="deleteOrganization(row.organizationId)">Delete</button>
            <button (click)="editOrganization(row.organizationId)">Edit</button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>